import React, { useState, useEffect } from 'react';
import { Wrapper, MainWrapper } from './style'
import { useRouter } from 'next/router';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components
import Doctors from './Doctors';
import Filtering from './Filtering';
import MobileHeader from './MobileHeader';
import InnerLinks from './InnerLinks';
import Description from './Description';

// Libs
import Translation from 'libs/Translation';

const DoctorsFeed = ({ city, specialty, educationLevel, name, title, doctors, doctorsCount, webConfig, lastBreadCrumb, faqList, cities, specialties, educationLevels, params, pageURL }) => {
    const [count, setCount] = useState();
    const router = useRouter();
    const page = parseInt(router.query.page || '1', 10);
    const mobileView = useMediaQuery('(max-width:600px)');

    // Paginate doctors list
    useEffect(() => {
        let _count = Math.ceil(doctorsCount/20);
        setCount(_count);
    }, [doctorsCount])

    return (
    <MainWrapper>
        <Wrapper webConfig={webConfig}>
            <MobileHeader 
                webConfig={webConfig}
                cities={[{Title: Translation.t('label.all-cities'), Slug: 'IR'}, ...cities]}
                specialties={[{Title: Translation.t('label.all-specialties'), Slug: 'all'}, ...specialties]}
                educationLevels={[{Title: Translation.t('label.all-education-levels'), Slug: 'all'}, ...educationLevels]}
                name={name}
                specialty={specialty}
                city={city}
                educationLevel={educationLevel}
                params={params}
                pageURL={pageURL}
            />
            <Filtering 
                webConfig={webConfig}
                cities={[{Title: Translation.t('label.all-cities'), Slug: 'IR'}, ...cities]}
                specialties={[{Title: Translation.t('label.all-specialties'), Slug: 'all'}, ...specialties]}
                educationLevels={[{Title: Translation.t('label.all-education-levels'), Slug: 'all'}, ...educationLevels]}
                name={name}
                specialty={specialty}
                city={city}
                educationLevel={educationLevel}
                params={params}
                pageURL={pageURL}
            />
            <Doctors
			    doctors={doctors}
                webConfig={webConfig}
                page={page}
                count={count}
                lastBreadCrumb={lastBreadCrumb}
                title={title}
                specialty={specialty}
                city={city}
                params={params}
                mobileView={mobileView}
                faqList={faqList}
                pageURL={pageURL}
		    />
        </Wrapper> 
        {/* <InnerLinks 
            specialty={specialty}
        /> */}
        <Description />
    </MainWrapper>   
    )
}

export default DoctorsFeed;
